import { tns } from "tiny-slider";

export default function(el) {
    const sliderEl = el.querySelector(".slider");
    const slidesCount = el.querySelectorAll(".slider__slide").length;
    const pagination = el.querySelectorAll(".slider__pagination span");
    let config = {};

    const updatePaginationPart = (part, index) => (part.innerText = index);

    const updateActiveSlideClass = (sliderInfo, index = null) => {
        const activeClass = "slider__slide--active";

        sliderInfo.slideItems[index ? index : sliderInfo.indexCached].classList.remove(activeClass);
        sliderInfo.slideItems[index ? index : sliderInfo.index].classList.add(activeClass);
    };

    if (!sliderEl || slidesCount < 2) return;

    if (el.dataset.config) {
        try {
            config = JSON.parse(el.dataset.config);
        } catch (e) {
            console.log(e); // Remove this after all
        }
    }

    const slider = tns({
        container: sliderEl,
        nav: false,
        autoplayButtonOutput: false,
        prevButton: el.querySelector(".slider__button--prev"),
        nextButton: el.querySelector(".slider__button--next"),
        mouseDrag: true,
        gutter: 20,
        onInit(sliderInfo) {
            if (pagination[0]) updatePaginationPart(pagination[0], sliderInfo.displayIndex);
            if (pagination[1]) updatePaginationPart(pagination[1], slidesCount);

            updateActiveSlideClass(sliderInfo, 0);
        },
        ...config,
    });

    slider.events.on("indexChanged", (sliderInfo) => {
        if (pagination[0]) updatePaginationPart(pagination[0], sliderInfo.displayIndex);

        if (!(config && config.autoplayTimeout && config.autoplayTimeout === 0))
            updateActiveSlideClass(sliderInfo);
    });

    return slider;
}
